import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative z-50 flex -translate-y-80 flex-col items-center px-5" }

import {computed, type HTMLAttributes} from "vue";
import {cn} from "@/lib/utils";

interface LampEffectProps {
  delay?: number;
  duration?: number;
  class?: HTMLAttributes["class"];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LampEffect',
  props: {
    delay: { default: 0.5 },
    duration: { default: 0.8 },
    class: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "d6b4be0c": (durationInSeconds.value),
  "4ba1ad43": (delayInSeconds.value)
}))

const props = __props;

const durationInSeconds = computed(() => `${props.duration}s`);
const delayInSeconds = computed(() => `${props.delay}s`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(
      _unref(cn)(
        'relative flex min-h-screen flex-col items-center justify-center overflow-hidden _bg_color_pro-rot w-full rounded-md z-0',
        _ctx.$props.class,
      )
    )
  }, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"relative isolate z-0 flex w-full flex-1 scale-y-125 items-center justify-center\" data-v-0b06d2e5><div style=\"background-image:conic-gradient(var(--conic-position), var(--tw-gradient-stops));\" class=\"animate-conic-gradient bg-gradient-conic absolute inset-auto right-1/2 h-56 w-60 overflow-visible from-cyan-500 via-transparent to-transparent text-white opacity-50 [--conic-position:from_70deg_at_center_top]\" data-v-0b06d2e5><div class=\"absolute bottom-0 left-0 z-20 h-40 w-full _bg_color_pro-rot [mask-image:linear-gradient(to_top,white,transparent)]\" data-v-0b06d2e5></div><div class=\"absolute bottom-0 left-0 z-20 h-full w-40 _bg_color_pro-rot [mask-image:linear-gradient(to_right,white,transparent)]\" data-v-0b06d2e5></div></div><div style=\"background-image:conic-gradient(var(--conic-position), var(--tw-gradient-stops));\" class=\"animate-conic-gradient bg-gradient-conic absolute inset-auto left-1/2 h-56 w-60 from-transparent via-transparent to-cyan-500 text-white opacity-50 [--conic-position:from_290deg_at_center_top]\" data-v-0b06d2e5><div class=\"absolute bottom-0 right-0 z-20 h-full w-40 _bg_color_pro-rot [mask-image:linear-gradient(to_left,white,transparent)]\" data-v-0b06d2e5></div><div class=\"absolute bottom-0 right-0 z-20 h-40 w-full bg_color_pro-rot [mask-image:linear-gradient(to_top,white,transparent)]\" data-v-0b06d2e5></div></div><div class=\"absolute top-1/2 h-48 w-full translate-y-12 scale-x-150 bg_color_pro-rot blur-2xl\" data-v-0b06d2e5></div><div class=\"absolute top-1/2 z-50 h-48 w-full bg-transparent opacity-10 backdrop-blur-md\" data-v-0b06d2e5></div><div class=\"absolute inset-auto z-50 h-36 w-[28rem] -translate-y-1/2 rounded-full bg-cyan-500 opacity-50 blur-3xl\" data-v-0b06d2e5></div><div class=\"animate-spotlight absolute inset-auto z-30 h-36 w-32 -translate-y-24 rounded-full bg-cyan-400 blur-2xl\" data-v-0b06d2e5></div><div class=\"animate-glowing-line absolute inset-auto z-50 h-0.5 w-60 -translate-y-28 bg-cyan-400\" data-v-0b06d2e5></div><div class=\"absolute inset-auto z-40 h-44 w-full translate-y-[-12.5rem] bg_color_pro-rot\" data-v-0b06d2e5></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})